import React, { useEffect } from 'react';
import DependentControlComponent from './NewControls/DependentControlComponent';
import { getControlStyle, fetchColorArray, matchRule, cellFillColours } from '../../../../../Components/helper';
import { useCustomModuleState } from '../../Context/index';
import CommonAction from './CommonAction';

function getCellFillColour(relation, finalValue) {
  if (relation?.colourArray && finalValue) {
    const newArray = fetchColorArray(relation?.colourArray || []);
    const matchingRule = newArray?.find((rule) => matchRule(rule, finalValue));
    return cellFillColours(matchingRule?.colourType);
  }
  return null;
}

function DependentControl({
  label,
  index,
  gridIndex,
  onChange,
  duplicatingItem,
  pageIndex,
  fromForm,
  showDelete,
  handleSupplierPermission,
  supplierVisible,
  editingInput,
  deleteItem,
  setOnElement,
  onElement,
  otherConfiguration,
  isEditDependent,
  isDependent,
  setIsDependent,
  setDroppedIndex,
  setIsEditDependent,
  boldLabel,
  handleStaticGrid,
  isStatic,
  relation,
}) {
  const { customModuleState } = useCustomModuleState();
  const combinedStyles = getControlStyle(otherConfiguration);
  const showEdit = customModuleState?.modalEdit ? isEditDependent : isDependent;

  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const handleColour = () => getCellFillColour(relation, relation?.value || relation?.dropDownControl?.control?.value);
  return !showEdit ? (
    <StaticView
      label={label}
      fromForm={fromForm}
      boldLabel={boldLabel}
      combinedStyles={combinedStyles}
      relation={relation}
      handleColour={handleColour}
      onElement={onElement}
      editingInput={editingInput}
      gridIndex={gridIndex}
      pageIndex={pageIndex}
      showDelete={showDelete}
      deleteItem={deleteItem}
      handleDuplicateItem={handleDuplicateItem}
      supplierVisible={supplierVisible}
      handleSupplierPermission={handleSupplierPermission}
      handleStaticGrid={handleStaticGrid}
      isStatic={isStatic}
    />
  ) : (
    <EditDependentView
      setIsDependent={setIsDependent}
      showEdit={showEdit}
      gridIndex={gridIndex}
      pageIndex={pageIndex}
      index={index}
      deleteItem={deleteItem}
      onChange={onChange}
      setIsEditDependent={setIsEditDependent}
      setDroppedIndex={setDroppedIndex}
    />
  );
}

function StaticView({
  label,
  fromForm,
  boldLabel,
  combinedStyles,
  relation,
  handleColour,
  onElement,
  editingInput,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  handleDuplicateItem,
  supplierVisible,
  handleSupplierPermission,
  handleStaticGrid,
  isStatic,
}) {
  const finalValue = relation?.dropDownControl?.control?.value || '';
  function handleContentArr(controlValue) {
    const isContent = relation?.isContentArr?.find((item) => item?.isContent?.name === controlValue?.name);
    if (isContent?.to) {
      return isContent?.to;
    }
    return '';
  }
  useEffect(() => {
    if (finalValue && !relation?.value) {
      relation.value = relation?.fixed ? handleContentArr(finalValue) : finalValue;
    }
  }, [finalValue, relation]);

  return (
    <div className={`${!relation?.fixed && handleColour()} h-100`}>
      <label className={`fs-custom-module asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</label>
      <div style={combinedStyles}>
        <p className="fs-custom-module">{relation?.value}</p>
      </div>
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  );
}

function EditDependentView({ setIsDependent, showEdit, gridIndex, pageIndex, index, deleteItem, onChange, setIsEditDependent, setDroppedIndex }) {
  return (
    <DependentControlComponent
      setIsDependent={setIsDependent}
      showEdit={showEdit}
      gridIndex={gridIndex}
      pageIndex={pageIndex}
      index={index}
      deleteItem={deleteItem}
      onChange={onChange}
      setIsEditDependent={setIsEditDependent}
      setDroppedIndex={setDroppedIndex}
    />
  );
}

export default DependentControl;
